<form>
  <mat-form-field class="full-width">
    <input matInput fxFlexFill placeholder="type your message"
       name="text"
       [(ngModel)]="text" (keyup.enter)="close()">
  </mat-form-field>
</form>
